import { render, staticRenderFns } from "./SysLangSetting.vue?vue&type=template&id=6c21d28a"
import script from "./SysLangSetting.vue?vue&type=script&lang=js"
export * from "./SysLangSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports